import React from 'react';
import ReactDOM from 'react-dom/client';
import { inject } from '@vercel/analytics';
import App from './App';
import './index.css';
import { initAnalytics } from './src/services/analytics';

// Initialize Vercel Web Analytics
inject();

// Initialize PostHog Analytics after a short delay to avoid blocking initial page load
setTimeout(() => {
  initAnalytics();
}, 2500);

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);